import { style } from '@vanilla-extract/css';

export const switchElement = style({
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: 'var(--padding)',
  gap: 'var(--gap)',
});

export const label = style({
  color: 'var(--label-text-color)',
});

export const switchRoot = style({
  width: '35px',
  height: '20px',
  borderRadius: '9999px',
  position: 'relative',
  border: 'solid 1px #E5E7EB',
  backgroundColor: 'var(--background-color)',
});

export const switchThumb = style({
  display: 'block',
  width: '16px',
  height: '16px',
  backgroundColor: 'var(--thumb-color)',
  borderRadius: '9999px',
  border: 'solid 1px #E5E7EB',
  transition: 'transform 100ms',
  transform: 'translateX(2px)',
  selectors: {
    "&[data-state='checked']": {
      transform: 'translateX(16px)',
    },
  },
});
